<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="clearfix flex justify-between">
          <span>{{ $t('serviceProvideRemarkView.title') }}</span>
        </div>

        <el-form :model="remarkForm" label-width="120px">
          <el-form-item :label="$t('serviceProvideRemarkView.description')">
            <el-input
              type="textarea"
              :rows="10"
              v-model="remarkForm.description"
              :placeholder="$t('serviceProvideRemarkView.descriptionPlaceholder')">
            </el-input>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'ServiceProvideRemarkView',
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      remarkForm: {
        flowComponent: 'serviceProvideRemarkView',
        description: ''
      }
    }
  },
  watch: {
    remarkForm: {
      deep: true,
      handler(newVal) {
        this.$emit('notify', newVal)
      }
    }
  },
  created() {
    console.log(this.index)
  }
}
</script>